


































































import { defineComponent, ref } from '@vue/composition-api';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import visible from '@front-app/directives/visible';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import TrForm from '@front-app/components/form/Form.vue';
import FormSection from '@front-app/components/form/FormSection.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormInput from '@front-app/components/form/FormInput.vue';
import FormError from '@front-app/components/form/FormError.vue';
import { Size, Spacing } from '@front-app/components/constants';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';

export default defineComponent({
	components: {
		CtaButton,
		TrForm,
		FormSection,
		FormInput,
		FormLabel,
		FormError,
	},
	directives: {
		visible,
	},
	setup(props, ctx) {
		const email = ref('');
		const password = ref('');
		const hasGenericError = ref(false);
		const forgotPasswordLink = `${process.env.VUE_APP_TRAPP_PUBLIC_URL}/app/forgottenPwd.shtml?execution=e2s1`;
		const registerLink = `${process.env.VUE_APP_TRAPP_PUBLIC_URL}/app/register.shtml`;

		const { logIn } = CurrentUserStore.actions;

		const showError = () => {
			hasGenericError.value = true;
		};
		const hideError = () => {
			hasGenericError.value = false;
		};

		const { track, isLoading } = useAsyncStatus();
		const handleSubmit = () => {
			track(logIn(email.value, password.value)
				.then(() => ctx.emit('login-complete'))
				.catch(() => showError()));
		};
		return {
			email,
			password,
			hasGenericError,
			forgotPasswordLink,
			registerLink,
			ButtonPalettes,
			Spacing,
			Size,
			logIn,
			handleSubmit,
			isLoading,
			showError,
			hideError,
		};
	},
});
